import React, { useEffect, useState, useRef } from "react";
import {
  FaFingerprint,
  FaLock,
  FaShieldAlt,
  FaUserShield,
} from "react-icons/fa";

const SECURITY_BULLETS = [
  {
    icon: <FaFingerprint />,
    title: "Biometria & senha",
    text: "Login com Face ID, digital e PIN seguro a cada acesso.",
  },
  {
    icon: <FaLock />,
    title: "Criptografia ponta a ponta",
    text: "Suas informações sempre cifradas — em trânsito e em repouso.",
  },
  {
    icon: <FaShieldAlt />,
    title: "Monitoramento 24/7",
    text: "Antifraude inteligente acompanha cada transação em tempo real.",
  },
  {
    icon: <FaUserShield />,
    title: "Você no controle",
    text: "Bloqueio do cartão, limites e alertas direto pelo app.",
  },
];

export const Team = (props) => {
  const [isVisible, setIsVisible] = useState(false);
  const appRef = useRef(null);

  useEffect(() => {
    const currentApp = appRef.current;
    const observer = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting) {
          setIsVisible(true);
          if (currentApp) observer.unobserve(currentApp);
        }
      },
      { threshold: 0.1 }
    );

    if (currentApp) {
      observer.observe(currentApp);
    }

    return () => {
      if (currentApp) {
        observer.unobserve(currentApp);
      }
    };
  }, []);

  return (
    <section
      id="app"
      className={isVisible ? "is-visible" : ""}
      ref={appRef}
    >
      <div className="container">
        <div className="app-grid">
          <div className="app-visual">
            <div className="app-device-frame">
              <div className="app-device-halo" aria-hidden="true"></div>
              <img
                src="img/arco-app.png"
                className="app-device-image"
                alt={`Aplicativo ${props.bankName || "CORE bank"}`}
              />
            </div>
          </div>

          <div className="app-content">
            <span className="app-eyebrow">
              <span className="app-eyebrow-dot" aria-hidden="true"></span>
              Conta segura
            </span>
            <h2>Segurança bancária em cada toque</h2>
            <p className="app-paragraph">
              {props.data
                ? props.data.paragraph
                : "Sua conta CORE bank é protegida por criptografia, biometria e monitoramento contínuo."}
            </p>

            <ul className="app-bullets" aria-label="Recursos de segurança">
              {SECURITY_BULLETS.map((bullet, idx) => (
                <li key={idx} className="app-bullet">
                  <span className="app-bullet-icon" aria-hidden="true">
                    {bullet.icon}
                  </span>
                  <div>
                    <strong>{bullet.title}</strong>
                    <p>{bullet.text}</p>
                  </div>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
};
